export default "__VITE_ASSET__E3vBRGBE__"